import { dispatcher } from '../dispatcher/dispatcher';
import Constants from '../constants/constants';
import { storeUtils } from './util';
const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var CHANGE_EVENT = 'change';

var _excluding = false;
var _navigating = true;
var _visible = false;
var _autoCenterAndZoom = true; //Default the auto center and zoom to true
var _exclusionList = [];


var dispatchToken = dispatcher.register(function (action) {


    switch (action.type) {

        case ActionTypes.EXCLUSION_LIST_UPDATED:
            _exclusionList = action.exclusionList;
            _events.trigger(CHANGE_EVENT);
            break;

        //case ActionTypes.SET_DESELECT:
        //    _deselecting = true;
        //    _selecting = false;
        //    _navigating = false;
        //    _events.trigger(CHANGE_EVENT);
        //    break;

        case ActionTypes.SET_EXCLUDE:
            //_deselecting = true;
            // _excluding = true;  //TODO Turn this back on when deselect is ready
            // _navigating = false;
            _events.trigger(CHANGE_EVENT);
            break;

        //case ActionTypes.SET_SELECT:
        //    _deselecting = false;
        //    _selecting = true;
        //    _navigating = false;
        //    _events.trigger(CHANGE_EVENT);
        //break;

        case ActionTypes.SET_NAVIGATE:
            //_deselecting = false;
            _excluding = false;
            _navigating = true;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.SHOW_SCHEMATIC:
            _visible = true;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.HIDE_SCHEMATIC:
            _visible = false;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.CENTER_ZOOM_CHANGED:
            _autoCenterAndZoom = action.checked;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.RESET_COMPARE_DETAILS:
            _autoCenterAndZoom = false;
            _events.trigger(CHANGE_EVENT);
            break;


        default:
        // no-op
    }
});

export const schematicToolbarStore = {
    dispatchToken,
    subscribe: _events.on,
    unsubscribe: _events.off,
    isNavigating: function () {
        return _navigating;
    },
    isExcluding: function () {
        return _excluding;
    },
    //isSelecting: function(){return _selecting;},
    //isDeselecting: function(){return _deselecting;},
    isVisible: function () {
        return _visible
    },
    getExclusionList: function () {
        return _exclusionList
    },
    canAutoCenterAndZoom: function () {
        return _autoCenterAndZoom;
    }
};
